import { B2BTextField } from "@hopper-b2b/ui";
import {
  useReplaceMaterialUI,
  useNativeTextInputs,
} from "@hopper-b2b/utilities";
import type { TextFieldProps as MuiTextFieldProps } from "@material-ui/core";
import { CustomInput } from "./CustomInput";
import { NativeInput } from "./NativeInput";

interface TextFieldProps {
  onChange?: (value: string) => void;
  onBlur?: (value: string) => void;
  onFocus?: (
    value: string,
    event?: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => void;
  errorHelper?: string;
  width?: string;
  allowInputSizeOverride?: boolean;
  variant?: "filled" | "outlined" | "standard" | "default";
}

export type ITextField = TextFieldProps &
  Omit<MuiTextFieldProps, "onChange" | "onBlur" | "onFocus" | "variant">;

export const TextField = (props: ITextField) => {
  const replaceMuiInput = useReplaceMaterialUI();
  const nativeInputs = useNativeTextInputs();

  // Priority 1: Native inputs (for iOS Safari iframe fix)
  if (nativeInputs) {
    // Destructure autoCapitalize to avoid type conflict between MUI's string type
    // and NativeInput's stricter union type
    const { autoCapitalize, ...restProps } = props;
    return (
      <NativeInput
        value={props.value}
        defaultValue={props.defaultValue}
        autoCapitalize={
          autoCapitalize as
            | "off"
            | "none"
            | "on"
            | "sentences"
            | "words"
            | "characters"
            | undefined
        }
        {...restProps}
      />
    );
  }

  // Priority 2: CustomInput (for REPLACE_MATERIAL_UI experiment)
  if (replaceMuiInput) {
    return (
      <CustomInput
        value={props.value}
        defaultValue={props.defaultValue}
        ref={props.ref}
        {...props}
      />
    );
  }

  // Default: MUI TextField
  return <B2BTextField {...props} />;
};
